@use "Styles/components/buttons";
@use "Static/icons/icomoon/style.scss";


:host {
    .pagination {
        display: flex;
        align-items: center;
        gap: 12px;
    }
}
